<template>
  <div>
    <search-and-table-part
      :pagination="pagination"
      @getItems="getItems"
      @trdbClicked="checkItem"
      :items="items"
      :columns="columns"
      :idProperty="idProperty"
      :nameProperty="nameProperty"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasCheckDetail="true"
      :getTrigger="getTrigger"
    >
      <template slot="searchArea">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group d-flex col-12 p-0">
              <label
                for="searchBusinessId"
                class="col-3 col-form-label col-md-4 col-lg-3 col-xl-2"
                >營業人編號:</label
              >
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  id="searchBusinessId"
                  v-model="searchDTO.BusinessId"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <date-range-part
              :date="dateRange"
              :gridDegree="6"
              @dateChanged="dateChanged"
            />
          </div>
        </div>
      </template>
      <template slot="dataButtonAreaFront" slot-scope="props">
        <button
          class="btn btn-outline-primary btn-icon"
          type="button"
          @click="checkItem(items[props.index])"
        >
          <i class="fas fas fa-eye"></i>
        </button>
      </template>
    </search-and-table-part>
    <log-data
      :modalId="modalId"
      :item="item"
      :columns="columns"
      :isShow="isShow"
      @onClosed="onClosed"
    ></log-data>
  </div>
</template>

<script>
import searchAndTablePart from "@/components/parts/searchAndTablePart";
import dateRangePart from "@/components/parts/dateRangePart";
import logData from "@/components/datas/LogData";

import date from "@/filters/date";

export default {
  data() {
    return {
      items: [],
      item: {},
      columns: [
        { name: "CreateTime" },
        { name: "BusinessId" },
        { name: "UserId" },
        { name: "SystemLogTypeText" },
        { name: "Description" },
      ],
      searchDTO: {},
      pagination: {},
      idProperty: "SystemLogId",
      nameProperty: "",
      dateRange: {
        DayBegin: "",
        DayEnd: "",
      },
      isShow: false,
      modalId: "System",
      getTrigger: false,
    };
  },
  components: {
    searchAndTablePart,
    dateRangePart,
    logData,
  },
  methods: {
    getItems(dTO) {
      this.searchDTO.DayBegin = this.dateRange.DayBegin;
      this.searchDTO.DayEnd = this.dateRange.DayEnd;
      const d = { ...dTO, ...this.searchDTO };
      this.$api.logs.getSystemLogs(d).then((data) => {
        this.items = data.Datas;
        this.items.forEach((item) => {
          if (this.$enum.systemLogType.getByValue(item.SystemLogType)) {
            item.SystemLogTypeText = this.$enum.systemLogType.getByValue(
              item.SystemLogType
            ).text;
          }
        });
        this.pagination = data.Pagination;
      });
    },
    checkItem(i) {
      this.$api.logs.getSystemLog(i.SystemLogId).then((data) => {
        this.item = data;
        if (this.$enum.systemLogType.getByValue(this.item.SystemLogType)) {
          this.item.SystemLogTypeText = this.$enum.systemLogType.getByValue(
            this.item.SystemLogType
          ).text;
        }
        this.isShow = !this.isShow;
      });
    },
    onClosed() {
      this.isShow = !this.isShow;
    },
    dateChanged(begin, end) {
      this.dateRange.DayBegin = begin;
      this.dateRange.DayEnd = end;
    },
  },
};
</script>
